import axios from "axios";

const backendURL = axios.create({
  baseURL: "https://centralgroupbackend-920957317043.asia-south1.run.app/",
  headers: {
    "Content-Type": "application/json",
  },
});

export default backendURL;
